(() => {
  const sliders = document.querySelectorAll('[data-bpb-hero-slider]');
  sliders.forEach((root) => {
    if (root.dataset.bpbHeroReady === 'true') return;
    root.dataset.bpbHeroReady = 'true';

    const track = root.querySelector('[data-bpb-hero-track]');
    const slides = Array.from(root.querySelectorAll('[data-bpb-hero-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-bpb-hero-dot]'));
    const prev = root.querySelector('[data-bpb-hero-prev]');
    const next = root.querySelector('[data-bpb-hero-next]');
    if (!track || slides.length < 2) return;

    let index = 0;
    let scrollTimer;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setActive = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const goTo = (nextIndex, behavior = 'smooth') => {
      const target = (nextIndex + slides.length) % slides.length;
      track.scrollTo({ left: target * track.clientWidth, behavior: reduceMotion ? 'auto' : behavior });
      setActive(target);
    };

    prev?.addEventListener('click', () => goTo(index - 1));
    next?.addEventListener('click', () => goTo(index + 1));
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => goTo(dotIndex)));

    track.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        const width = track.clientWidth || 1;
        setActive(Math.round(track.scrollLeft / width));
      }, 80);
    }, { passive: true });

    window.addEventListener('resize', () => goTo(index, 'auto'));

    // The carousel stays on the selected slide; customers can use the arrows, dots, or swipe.
  });
})();
